import React from 'react';
import './StructureSelector.css';

const StructureSelector = ({ structures, selectedPath, onSelect }) => {
    if (!structures || structures.length === 0) {
        return null; 
    }

    // Button label: "<source set> – <method>" when the structure belongs to a
    // source set, otherwise fall back to the method (or generic type). The list
    // is already ordered by source_id from the backend.
    const labelOf = s => {
        const method = s.method && s.method !== 'Not available' ? s.method : null;
        if (s.source_name) return method ? `${s.source_name} – ${method}` : s.source_name;
        return method || s.type || 'Unknown';
    };

    const labelCounts = {};
    structures.forEach(s => {
        const key = labelOf(s);
        labelCounts[key] = (labelCounts[key] || 0) + 1;
    });

    const labelCounters = {};
    const items = structures.map(s => {
        const key = labelOf(s);
        const idx = (labelCounters[key] ?? 0) + 1;
        labelCounters[key] = idx;
        return { ...s, __methodKey: key, __methodIndex: idx, __needsNumber: labelCounts[key] > 1 };
    });

    return (
        <div className="structure-selector-container">
            <span className="selector-label">Available Structures:</span>
            <div className="selector-buttons">
                {items.map(structure => {
                    const btnText = structure.__needsNumber
                        ? `${structure.__methodKey} ${structure.__methodIndex}`
                        : structure.__methodKey;

                    const tooltip = [
                        structure.pdb_id && structure.pdb_id !== 'Not available' ? `PDB: ${structure.pdb_id}` : null,
                        `Type: ${structure.type}`,
                        structure.source_name ? `Structures set: ${structure.source_name}` : null,
                        structure.method ? `Method: ${structure.method}` : null,
                        structure.resolution ? `Resolution: ${structure.resolution} Å` : null,
                        structure.date ? `Date: ${structure.date}` : null,
                        structure.file_name ? `File: ${structure.file_name}` : null,
                    ].filter(Boolean).join(' • ');

                    return (
                        <button
                            key={structure.id ?? structure.file_name ?? structure.path}
                            onClick={() => onSelect(structure)}
                            className={`selector-button ${structure.path === selectedPath ? 'active' : ''}`}
                            title={tooltip}
                        >
                            {btnText}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default StructureSelector;